export default __webpack_public_path__ + "static/media/left-triangle-disabled.9ea515ea.svg";